// src/api/api.js
import axios from 'axios';

const API = axios.create({
  baseURL: 'https://api.vivcom.ae/api/',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

API.interceptors.request.use((config) => {
  const raw = localStorage.getItem('token');
  const token = raw && raw !== 'null' && raw !== 'undefined' ? raw : null;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    delete config.headers.Authorization;
  }
  return config;
});

export default API;
